<script setup lang="ts"></script>
<template>
  <h2 class="my-16 text-center text-4xl font-extrabold tracking-tighter text-gray-900 md:text-6xl">
    <slot />
  </h2>
</template>
